/**
 * Hitowa tenant customization bundle.
 *
 * The single entry point `customize/registry.ts` reads. The folders below
 * mirror `src/`, so a file lives where its RA2N counterpart would:
 *
 *   components/atoms/       src/components/atoms/     tenant-only atoms,
 *                           named Rah*, see ./README.md
 *   components/organisms/   src/components/organisms/  topbar, clinic filter
 *   components/templates/   src/components/templates/  the RAH shell frame
 *   constants/              src/constants/          tenant-wide constants
 *   pages/<feature>/        src/pages/<portal>/<feature>/  screens -- no portal
 *                           level here, see ./README.md
 *   router/                 src/router/             routes added to the router
 *   services/               src/services/           tenant-wide data access
 *   shared/guards/          src/shared/guards/      permission guards
 *   shared/layouts/         src/shared/layouts/     sidebar + menu trees
 *   shared/providers/       src/shared/providers/   tenant config and themes
 *   styles/                 src/styles/             ported ConceptDesign CSS
 *
 * What this tenant decides for itself is written up in `./README.md`.
 */
import type { TenantCustomization } from '../types';
import { hitowaAdminTheme } from './shared/providers/admin-theme/hitowaAdminTheme';
import { hitowaConfig } from './shared/providers/tenantConfig';
import { hitowaTheme } from './shared/providers/theme/hitowaTheme';
import { getHitowaClinicMenu } from './shared/layouts/menu';
import { hitowaClinicRoutes } from './router/routes';
import RahShell from './components/templates/RahShell';
import RahDashboardPage from './pages/dashboard/RahDashboardPage';

export const hitowaCustomization: TenantCustomization = {
  code: 'hitowa',
  name: hitowaConfig.name,
  description: hitowaConfig.description,
  enabled: hitowaConfig.enabled,

  theme: hitowaTheme,
  adminTheme: hitowaAdminTheme,
  config: hitowaConfig,

  getClinicMenu: getHitowaClinicMenu,
  clinicShell: RahShell,
  clinicIndex: RahDashboardPage,
  clinicRoutes: hitowaClinicRoutes,
};

export { hitowaConfig, hitowaTheme, hitowaAdminTheme };
export { useRahFunctionTiles } from './shared/providers/RahShellContext';
export type { RahTile } from './components/organisms/RahTopbar';

export default hitowaCustomization;
